import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NotificationDto } from 'src/app/interfaces/Dtos/notification-dto';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { Notifications } from 'src/app/services/shared/notifications.service';
import * as signalR from '@microsoft/signalr'
import { environment } from 'src/environments/environment';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'neoris-notifications-box-area',
  templateUrl: './notifications-box-area.component.html',
  styleUrl: './notifications-box-area.component.css'
})
export class NotificationsBoxAreaComponent implements OnInit, OnDestroy {

  private _hubConnection: signalR.HubConnection
  private arraySites: any[] = []
  notifications: NotificationDto[] = [];

  

  private onLanChange: Subscription
  private lang: string = "en";

  constructor(private notificationsService: Notifications,
    private controltowerservice: ControltowerService,
    private translate: TranslateService,
    private sanitizer: DomSanitizer) {

    


     }

  ngOnInit(): void {
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      console.log("lang change", this.lang)
    })

    this.getSites()
  }


  ngOnDestroy(): void {
    this.onLanChange.unsubscribe()  
  }

  public CloseNotification(notificacion) {
    this.notifications = this.notifications.filter(x => x.EventId != notificacion.EventId);
  }

  public hubConnected = true
  public hubConnecting = false

  connectionHub() {
    var hubUrl = environment.urlHubEventMonitor

    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(hubUrl)
      .withAutomaticReconnect() 
      .build()

    this._hubConnection.on('NewEventNotification', (data) => {

     
     
      var isNotificationSite = this.ValidateNotificationSite(data)
      var isNotificationUser = this.ValidateNotificationUsers(data)

      if (isNotificationSite) {

        if (isNotificationUser) {

          var firstImage = data.media[0]
          let objectURL = `data:image/${firstImage.extension};base64,` + firstImage.imageData;
          var image = this.sanitizer.bypassSecurityTrustUrl(objectURL);


          var notification = {
            EventId: data.eventId,
            SiteName: data.siteName,
            ClientId: "0",
            BusinessSiteId: "0",
            LocationName: data.incidentArea,
            EventDate: data.detectedDt,
            EventType: data.eventType.filter(f => f.localeCode == this.lang)[0].eventTypeName,
            IconUrl: data.iconUrl,
            ImageUrl: image as any
          }
          this.notifications.push(notification); 
     
        } else {
          console.log("No es una notificación para el usuario logueado")
        }
      }else{
        console.log("No es una notificación para el sitio logueado")
      }

    });

    this._hubConnection.onclose(() => {
      this.hubConnected = false;
      this.hubConnecting = false;
      
    });

    this._hubConnection.onreconnected(() => {
      this.hubConnected = true;
      this.hubConnecting = false;
    });

    this._hubConnection.onreconnecting(() => {
      this.hubConnected = false;
      this.hubConnecting = true;
    });


    this.startConnection();
  }




  private startConnection() {
    this._hubConnection.start().then(() => {
      this.hubConnected = true
    }).catch(
      () => this.hubConnected = false
    )
  }

  private ValidateNotificationSite(notificationData: any): boolean {
    const arraySitesId = this.arraySites.map(site => site.id)
    const containsSites = arraySitesId.includes(notificationData?.siteId)
    return containsSites;
  }

  private ValidateNotificationUsers(notificationData: any): boolean {

    const dataContacts = notificationData?.deviceAlerts.contacts || []
    const userName = JSON.parse(localStorage.getItem('ud'))[1].value

    console.log("userName", userName, dataContacts)
    const containsUsers = dataContacts.some(contact => contact.email == userName)

    return containsUsers;

  }

  private async getSites(): Promise<boolean> {

    console.log("get sites")
    return new Promise<boolean>((resolve, reject) => {
      this.controltowerservice.getSites().subscribe(
        {
          next: (sites: any) => {

            console.log("sites retrieved")
            this.arraySites = sites
            this.connectionHub()

            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            console.log("error on get sites")
            this.hubConnected = false
            resolve(false);
          }
        }
      )
    });
  }
}
